import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

function getSDM17DECs() {
    return dispatch => {
        return apiCaller
            .call(api.getAllSDM17DECs())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_SET_SDM17DECS',
                        SDM17DECs: data.SDM17DECs
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolSDM17DECs - ', error);
                throw error;
            });
    };
}
function getSDM17DECDetails(SDM17DECId) {
    return dispatch => {
        return apiCaller
            .call(api.getSDM17DECDetails(SDM17DECId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_SET_SDM17DEC_DETAILS',
                        SDM17DECId: SDM17DECId,
                        SDM17DECDetails: data.SDM17DECDetails,
                        SDM17DECLines: data.SDM17DECLines
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolSDM17DECDetails - ', error);
                throw error;
            });
    };
}
function refreshSDM17DECStatus(SDM17DECMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductCheckStatus('SDM17DEC', SDM17DECMac)
            .catch(error => {
                Logger.log('dataActions: refreshFHEPoolSDM17DECStatus - ', error);
                throw error;
            });
    };
}
function dissociateSDM17DECUser(SDM17DECMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUser('SDM17DEC', SDM17DECMac, userId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM17DECUser - ', error);
                throw error;
            });
    };
}
function dissociateSDM17DECUserAndSwitchMaster(SDM17DECMac, userId, masterId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUserAndSwitchMaster('SDM17DEC', SDM17DECMac, userId, masterId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM17DECUserAndSwitchMaster - ', error);
                throw error;
            });
    };
}
function switchSDM17DECMaster(SDM17DECMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductMasterSwitch('SDM17DEC', SDM17DECMac, userId)
            .catch(error => {
                Logger.log('dataActions: switchFHEPoolSDM17DECMaster - ', error);
                throw error;
            });
    };
}

export {
    getSDM17DECs,
    getSDM17DECDetails,
    refreshSDM17DECStatus,
    dissociateSDM17DECUser,
    dissociateSDM17DECUserAndSwitchMaster,
    switchSDM17DECMaster
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/SDM17DEC/actions.js